export const EDITOR_FONT_FAMILY_FORMATS =
  'Arial=arial,helvetica,sans-serif;' +
  'Courier New=courier new,courier,monospace;' +
  'Georgia=georgia,palatino,serif;' +
  'Roboto=roboto,sans-serif;' +
  'Times New Roman=times new roman,times,serif;' +
  'Verdana=verdana,geneva,sans-serif';

export const EDITOR_COLOR_MAP = [
  '231596',
  'Brand Primary',
  '000000',
  'Black',
  '34495E',
  'Dark Navy',
  '7E8C8D',
  'Dark Gray',
  '95A5A6',
  'Gray',
  'CED4D9',
  'Light Gray',
  'FFFFFF',
  'White',
  'E03E2D',
  'Red',
  'BA372A',
  'Dark Red',
  'E67E23',
  'Orange',
  'F1C40F',
  'Yellow',
  '2DC26B',
  'Green',
  '169179',
  'Dark Green',
  '3598DB',
  'Blue',
  '236FA1',
  'Dark Blue',
  'B96AD9',
  'Purple',
  '843FA1',
  'Dark Purple',
];

export const EDITOR_CONTENT_STYLE =
  // caret-color and link color are set explicitly so they render the same across
  // browsers — otherwise each browser falls back to its own default styling.
  'body { font-family: Arial, sans-serif; font-size: 11pt; line-height: 1.5; caret-color: #000; }' +
  ' a:not([data-cta]) { color: #231596; }';

export const EDITOR_FONT_SIZE_FORMATS = '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt';

export const SMS_CONTENT_MAX_LENGTH = 160;
export const CTA_DEFAULT_COLOR = '#231596';

export const EMAIL_TOOLBAR =
  'fontfamily fontsize | blocks | bold italic underline | forecolor | alignleft aligncenter alignright | bullist numlist | table hr | customlink ctabutton | emoticons';

export const SMS_TOOLBAR = 'customlink | emoticons';

// `hr` is a core toolbar button (no plugin needed).
export const EMAIL_PLUGINS = 'autolink emoticons lists advlist table';
export const SMS_PLUGINS = 'autolink emoticons';

export const TABLE_TOOLBAR =
  'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol';

// Keeps email table/list markup intact when editing imported templates —
// without this TinyMCE strips deprecated attributes (bgcolor/valign/align/width).
// `#` = pad this element with &nbsp; when empty. TinyMCE flags td/th/li that way by default, but
// declaring an element here replaces its rule, and an empty <td></td> then collapses once saved.
export const EMAIL_EXTENDED_VALID_ELEMENTS = [
  'a[href|target|rel|style|data-cta]',
  'table[style|class|width|height|border|cellpadding|cellspacing|bgcolor|align|role]',
  'colgroup',
  'col[span|style|width]',
  'thead',
  'tbody',
  'tfoot',
  'tr[style|class|bgcolor|align|valign]',
  '#td[style|class|width|height|bgcolor|align|valign|colspan|rowspan]',
  '#th[style|class|width|height|bgcolor|align|valign|colspan|rowspan|scope]',
  'ul[style|class]',
  'ol[style|class|start|type]',
  '#li[style|class]',
  'hr[style|class]',
].join(',');

export const SMS_EXTENDED_VALID_ELEMENTS = 'a[href|target|rel|style|data-cta]';
